// extracted by css-extract-rspack-plugin
export default {"container":"_f530420","background":"_da78cfc9","padding":"_8e237836"};